// RequestUserInfo.tsx
import React, { useEffect, useRef, useState } from 'react';
import { Blacked } from '../../../../CRM/components/styles';
import { ReactComponent as ModalCloseIcon } from '../../../../assets/HomeTownIcon/ModalCloseIcon.svg';
import { ReactComponent as RightArrowIcon } from '../assets/RightArrowIcon.svg';
import { ReactComponent as LeftArrowIcon } from '../assets/LeftArrowIcon.svg';

import styled from 'styled-components';
import { Input, message, Image } from 'antd';
import { MEDIA_URL } from '../../../../app/constants/APIKEYS';
import { useAdminUserInfo } from '../../../hooks/Admin/UserManage/GetAdminUserInfo';
import API from '../../../../utils/api';
import { useToken } from '../../../../app/hooks';


export const RequestUserInfo = ({ setRequestId, requestId, mutateUserList }) => {
  // 유틸리티
  const [storeLocation, setStoreLocation] = useState({ lat: 37.5665, lng: 126.978 });
  const [isPreviewModal, setIsPreviewModal] = React.useState(false); // 필요 시 사용
  const [mapReady, setMapReady] = useState<boolean>(() => !!window?.naver?.maps);
  const [mapLoadFailed, setMapLoadFailed] = useState(false); // 지도 스크립트 미로딩 시 방어
  // 지도/마커
  const mapContainerRef = useRef<HTMLDivElement | null>(null);
  const mapRef = useRef<any>(null);
  const markerRef = useRef<any>(null);

  // 데이터 조회
  const { adminUserInfo } = useAdminUserInfo(requestId);
  const { data: token } = useToken();
  console.log('//adminUserInfo',adminUserInfo)

  // 네이버 지도 스크립트 로딩 확인
  useEffect(() => {
    let cancelled = false;
    let rafId: number | null = null;
    let timerId: number | null = null;

    const check = () => {
      if (cancelled) return;
      if (window.naver?.maps) {
        setMapReady(true);
        setMapLoadFailed(false);
        return;
      }
      rafId = requestAnimationFrame(check);
    };

    if (!mapReady) {
      check();
      timerId = window.setTimeout(() => {
        if (!window.naver?.maps && !cancelled) {
          setMapLoadFailed(true);
          if (rafId) cancelAnimationFrame(rafId);
        }
      }, 4000);
    }

    return () => {
      cancelled = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (timerId) clearTimeout(timerId);
    };
  }, [mapReady]);
  // 지도 초기화 (스크립트는 외부에서 이미 로드됨)
  useEffect(() => {
    let mounted = true;
    if (!mapReady || mapLoadFailed) return;
    if (!mapContainerRef.current) return;
    if (mapRef.current) return;

    const init = () => {
      try {
        if (!mounted || !window.naver?.maps) return;
        const { naver } = window;

        mapRef.current = new naver.maps.Map(mapContainerRef.current, {
          center: new naver.maps.LatLng(storeLocation.lat, storeLocation.lng),
          zoom: 12,
        });

        markerRef.current = new naver.maps.Marker({
          position: new naver.maps.LatLng(storeLocation.lat, storeLocation.lng),
          map: mapRef.current,
        });
      } catch (err) {
        console.error('네이버 지도 초기화 실패', err);
        setMapLoadFailed(true);
      }
    };

    if (window.naver?.maps) {
      init();
    } else {
      // 외부에서 커스텀 이벤트를 안 쏘면 rAF로 폴링
      const tick = () => {
        if (!mounted) return;
        if (window.naver?.maps) init();
        else requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    return () => {
      mounted = false;
      if (markerRef.current) {
        markerRef.current.setMap(null);
        markerRef.current = null;
      }
      // mapRef는 SDK가 정리
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapLoadFailed, mapReady]);

  // 주소 → 좌표 변환 + 지도/마커 반영
  const setLocation = (fullAddress: string) => {
    const { naver } = window;
    if (!naver?.maps || !mapReady || mapLoadFailed) return;
    if (!fullAddress) return;

    if (!naver?.maps?.Service?.geocode) {
      console.error('네이버 지오코더가 준비되지 않았습니다.');
      return;
    }

    naver.maps.Service.geocode({ query: fullAddress }, (status: any, response: any) => {
      if (status === naver.maps.Service.Status.OK) {
        const result = response?.v2?.addresses?.[0];
        const lat = parseFloat(result?.y);
        const lng = parseFloat(result?.x);
        if (!isNaN(lat) && !isNaN(lng)) {
          setStoreLocation({ lat, lng });

          if (mapRef.current && naver?.maps?.LatLng) {
            const pos = new naver.maps.LatLng(lat, lng);
            mapRef.current.setCenter(pos);
            mapRef.current.setZoom(12);
            if (markerRef.current) {
              markerRef.current.setPosition(pos);
            } else {
              markerRef.current = new naver.maps.Marker({ position: pos, map: mapRef.current });
            }
          }
        }
      } else {
        console.error('Geocoding failed:', response);
        message.error('해당 주소는 검색할 수 없습니다.');
      }
    });
  };

  // adminUserInfo가 로드되면 위치 갱신
  useEffect(() => {
    if (adminUserInfo?.address) {
      setLocation(adminUserInfo.address);
    }
  }, [adminUserInfo?.address]);

  const putAdminUser = (type: string, value: number, name: string) => {
    const shouldEdit = window.confirm(`${name}하시겠습니까?`);
    if (!shouldEdit) return;

    API.put('/admin/user/list', token + '', {
      ids: [requestId],
      type,
      value,
    })
        .then((res: any) => {
          if (res.result?.success) {
            message.success('수정되었습니다');
            mutateUserList();
          } else {
            message.error(res.result?.message || '실패하였습니다');
          }
        })
        .catch(() => {
          message.error('실패하였습니다');
        });
  };


  console.log('//data',adminUserInfo);
  return (
      <>
        <Blacked onClick={() => setRequestId(null)} />
        <ModalWrapper className="scroll-container">
          <ModalHeader>
            <ModalTitle>{'부동산중개소 정보'}</ModalTitle>
            <CloseIconSVG as={ModalCloseIcon} onClick={() => setRequestId(null)} />
          </ModalHeader>

          <MapWrapper>
            {/* 공식 SDK로 직접 렌더 */}
            <MapArea>
              <div style={{ width: '100%', height: '100%' }} ref={mapContainerRef} />
              {!mapReady && !mapLoadFailed && (
                  <MapStatus>지도를 불러오는 중입니다…</MapStatus>
              )}
              {mapLoadFailed && (
                  <MapStatus>지도 로딩에 실패했습니다. 새로고침 후 다시 시도해주세요.</MapStatus>
              )}
            </MapArea>
          </MapWrapper>

          <Table>
            <tbody>
            <TableRow>
              <Th>
                <ThLabel>부동산</ThLabel>
              </Th>
              <Td>{adminUserInfo?.store}</Td>
              <Th>
                <ThLabel>대표자</ThLabel>
              </Th>
              <Td>{adminUserInfo?.name}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>주소</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.address}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>매체정보</ThLabel>
              </Th>
              <Td colSpan={3}>
                {`${adminUserInfo?.mediaInfo || '-'}, ${adminUserInfo?.mediaType || '-'}`}
              </Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>매체 운영시간</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.businessHours?.replace(/,/g, '') || '-'}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>사진</ThLabel>
              </Th>
              <Td colSpan={3}>
                {adminUserInfo?.fileList?.filter((item: any) => item?.type === 'IMG')?.length
                    ? adminUserInfo?.fileList
                        ?.filter((item: any) => item?.type === 'IMG')
                        ?.map((item: any, index: number) => (
                            <Image
                                key={`img-${index}`}
                                alt={item?.url}
                                style={{ width: '50%', margin: '0 2px' }}
                                src={MEDIA_URL + item?.url}
                            />
                        ))
                    : '-'}
              </Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>유동인구 및 상권</ThLabel>
              </Th>
              <Td colSpan={3}>
                <GraphWrapper>
                  <div>{`일평균 유동인구 등급: ${adminUserInfo?.footTrafficGrade}`}</div>

                  {adminUserInfo?.fileList?.filter((item: any) => item?.type === 'FT')?.length
                      ? adminUserInfo?.fileList
                          ?.filter((item: any) => item?.type === 'FT')
                          ?.map((item: any, index: number) => (
                              <Image
                                  key={`ft-${index}`}
                                  alt={item?.url}
                                  style={{ width: '100%', margin: '0 2px' }}
                                  src={MEDIA_URL + item?.url}
                              />
                          ))
                      : '-'}
                </GraphWrapper>

                <GraphWrapper>
                  {adminUserInfo?.fileList?.filter((item: any) => item?.type === 'F')?.length
                      ? adminUserInfo?.fileList
                          ?.filter((item: any) => item?.type === 'F')
                          ?.map((item: any, index: number) => (
                              <Image
                                  key={`f-${index}`}
                                  alt={item?.url}
                                  style={{ width: '100%', margin: '0 2px' }}
                                  src={MEDIA_URL + item?.url}
                              />
                          ))
                      : '-'}
                </GraphWrapper>
              </Td>
            </TableRow>


            </tbody>
          </Table>

          <ButtonsWrapper>
            {/*<PrevNextText>*/}
            {/*  <ArrowSVG as={LeftArrowIcon} />*/}
            {/*  이전글*/}
            {/*</PrevNextText>*/}

            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <RegistButton onClick={() => putAdminUser('accept', 1, '가입승인')}>승인</RegistButton>
              <CancelButton onClick={() => putAdminUser('accept', 0, '가입승인거절')}>거절</CancelButton>
            </div>

            {/*<PrevNextText>*/}
            {/*  다음글*/}
            {/*  <ArrowSVG as={RightArrowIcon} />*/}
            {/*</PrevNextText>*/}
          </ButtonsWrapper>
        </ModalWrapper>
      </>
  );
};

/* ========================= Styles ========================= */

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const RegistButton = styled.div`
  width: 100px;
  height: 40px;
  padding: 11px;
  color: white;
  background-color: #530dad;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  font-size: 15px;
  line-height: 17.9px;
  font-family: Pretendard, sans-serif;
`;

const PrevNextText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16.71px;
  font-family: Pretendard, sans-serif;
  color: #00000099;
  cursor: pointer;
`;

const ArrowSVG = styled.svg`
  width: 20px;
`;

const GraphWrapper = styled.div``;

const GraphContents = styled.div`
  display: flex;
  align-items: center;
`;

const LabelContents = styled.div`
  width: 100px;
`;

const LabelTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const ColorBadge = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  width: 7px;
  height: 7px;
  border-radius: 50px;
  margin-right: 4px;
`;

const LabelText = styled.div`
  display: flex;
  font-size: 11px;
  align-items: center;
  margin-bottom: 4px;
`;

const LabelValue = styled.div`
  font-weight: 600;
  margin-left: 10px;
`;

const GraphTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  font-weight: 600;
`;

const GraphSubTitle = styled.div`
  color: #00000099;
  font-size: 14px;
`;

const MapWrapper = styled.div``;

const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 900px;
  width: 600px;
  min-height: 411px;
  background-color: #fff;
  overflow-y: auto;
  border-radius: 8px;
  padding: 24px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 21.5px;
`;

const CloseIconSVG = styled.svg`
    width: 24px;
    cursor: pointer;
`;

const MapArea = styled.div`
    position: relative;
    width: 532px;
    height: 295px;
`;

const MapStatus = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    text-align: center;
    background: rgba(255, 255, 255, 0.85);
    color: #111;
    font-weight: 600;
    border-radius: 4px;
`;

const ModalTitle = styled.div`
    font-family: Pretendard, sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 21.48px;
  color: #2e2559;
`;

const Table = styled.table`
  width: 100%;
  margin-top: 8px;
  border-collapse: collapse;
  border: 1px solid #ccc;
`;

const TableRow = styled.tr`
  min-height: 40px;
`;

const Th = styled.th`
  padding: 10px;
  text-align: left;
  width: 20%;
  border: 1px solid #ccc;
  background-color: #f4f2ff;
  vertical-align: middle;
`;

const ThLabel = styled.div`
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.71px;
  color: #00000099;
  display: flex;
  gap: 2px;
`;

const RequireIcon = styled.p`
  color: #f15151;
`;

const Td = styled.td`
  padding: 10px;
  text-align: left;
  border: 1px solid #ccc;
`;

const InputText = styled(Input)`
  width: 100%;
  height: 28px;
  padding-left: 10px;
  border: 1px solid #2e2559;
  border-radius: 4px;
  display: flex;
`;

const CancelButton = styled.div`
  width: 100px;
  padding: 11px;
  border: 1px solid #000000;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  font-size: 15px;
  line-height: 17.9px;
  font-family: Pretendard, sans-serif;
`;
